 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"canteenSelector":"canteenSelector","auth":"auth","profile~summary":"profile~summary","summary":"summary","checkout":"checkout","profile":"profile","restaurant":"restaurant","restaurantBrand~restaurantFeaturedList~restaurantList~restaurantPopularList":"restaurantBrand~restaurantFeaturedList~restaurantList~restaurantPopularList","restaurantBrand":"restaurantBrand","notFound":"notFound","restaurantFeaturedList":"restaurantFeaturedList","restaurantList":"restaurantList","restaurantPopularList":"restaurantPopularList"}[chunkId]||chunkId) + "." + {"canteenSelector":"015d2b12","chunk-2d22d1b7":"d84b69bb","chunk-57181d14":"f0d24602","chunk-cdc5d406":"8091e3a5","auth":"58ce2f34","profile~summary":"6c9e28ef","summary":"5297977d","chunk-d07633d6":"f4706c8e","chunk-be7850a6":"eed24d36","chunk-16321b00":"eb01bc82","checkout":"10cf8d14","profile":"925989f1","chunk-267383ca":"4ceb839b","restaurant":"6dd77754","restaurantBrand~restaurantFeaturedList~restaurantList~restaurantPopularList":"9c9524a5","chunk-7052f036":"0a6bb60c","restaurantBrand":"002fd9e7","notFound":"cb45844f","restaurantFeaturedList":"73d91858","restaurantList":"1a4ca42b","restaurantPopularList":"f59c4bf2","chunk-2d0c7344":"f62c9694","chunk-2d0c8272":"3261ea1a","chunk-2d217343":"731b4f1c","chunk-3ccae282":"9267df09","chunk-4394b7a7":"9e91977d","chunk-2d0d7dd6":"4e24bf2c","chunk-1157a99f":"eda869e0","chunk-782ed71b":"71047fcd","chunk-80b9d60a":"bac4a6c6","chunk-eb1d459c":"9d94e4ec","chunk-2d0a34d6":"7f8f5c65","chunk-2d0de694":"dc472a11","chunk-c78bece0":"e8d6ff4e","chunk-3d3f4c9b":"89162e05","chunk-2d0bd3b4":"4cc16120"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"summary":1,"chunk-d07633d6":1,"chunk-be7850a6":1,"checkout":1,"profile":1,"chunk-267383ca":1,"restaurant":1,"chunk-4394b7a7":1,"chunk-1157a99f":1,"chunk-eb1d459c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"canteenSelector":"canteenSelector","auth":"auth","profile~summary":"profile~summary","summary":"summary","checkout":"checkout","profile":"profile","restaurant":"restaurant","restaurantBrand~restaurantFeaturedList~restaurantList~restaurantPopularList":"restaurantBrand~restaurantFeaturedList~restaurantList~restaurantPopularList","restaurantBrand":"restaurantBrand","notFound":"notFound","restaurantFeaturedList":"restaurantFeaturedList","restaurantList":"restaurantList","restaurantPopularList":"restaurantPopularList"}[chunkId]||chunkId) + "." + {"canteenSelector":"31d6cfe0","chunk-2d22d1b7":"31d6cfe0","chunk-57181d14":"31d6cfe0","chunk-cdc5d406":"31d6cfe0","auth":"31d6cfe0","profile~summary":"31d6cfe0","summary":"2bee7cea","chunk-d07633d6":"f80d45c6","chunk-be7850a6":"7514c749","chunk-16321b00":"31d6cfe0","checkout":"04712a59","profile":"ecd87b40","chunk-267383ca":"a4781e7e","restaurant":"3a2ba0ee","restaurantBrand~restaurantFeaturedList~restaurantList~restaurantPopularList":"31d6cfe0","chunk-7052f036":"31d6cfe0","restaurantBrand":"31d6cfe0","notFound":"31d6cfe0","restaurantFeaturedList":"31d6cfe0","restaurantList":"31d6cfe0","restaurantPopularList":"31d6cfe0","chunk-2d0c7344":"31d6cfe0","chunk-2d0c8272":"31d6cfe0","chunk-2d217343":"31d6cfe0","chunk-3ccae282":"31d6cfe0","chunk-4394b7a7":"4f4fbe58","chunk-2d0d7dd6":"31d6cfe0","chunk-1157a99f":"7514c749","chunk-782ed71b":"31d6cfe0","chunk-80b9d60a":"31d6cfe0","chunk-eb1d459c":"7514c749","chunk-2d0a34d6":"31d6cfe0","chunk-2d0de694":"31d6cfe0","chunk-c78bece0":"31d6cfe0","chunk-3d3f4c9b":"31d6cfe0","chunk-2d0bd3b4":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"restaurantBrand": [
 				"chunk-80b9d60a",
 				"chunk-1157a99f"
 			],
 			"restaurantFeaturedList": [
 				"chunk-7052f036",
 				"chunk-80b9d60a",
 				"chunk-1157a99f"
 			],
 			"restaurantList": [
 				"chunk-7052f036",
 				"chunk-80b9d60a",
 				"chunk-1157a99f"
 			],
 			"restaurantPopularList": [
 				"chunk-7052f036",
 				"chunk-80b9d60a",
 				"chunk-1157a99f"
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
